import axios from "axios";
import React, {useEffect, useState} from "react";
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import {Link} from 'react-router-dom';
import Swal from 'sweetalert2';
import {baseUrl, ipAddress, userLocation, userName} from '../../Univ.js'
function SurgeryType() {
    const [rows, setRows] = useState([]);
    const [viewsur, setViewsur] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [typeData, settypeData] = useState({
        "type": '',
        "amount": '',
        "status": '',
        "addedby": '',
        "ip_add": ''
    });
    const handleChange = (event) => {
        settypeData({
            ...typeData,
            [event.target.name]: event.target.value
        });
    }
    const formSubmit = () => {
        const _formData = new FormData();
        _formData.append('type', typeData.type);
        _formData.append('amount', typeData.amount);
        _formData.append('status', '1');
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
        _formData.append('location', userLocation);
        try {
            axios.post(baseUrl + 'surgery-type-create/', _formData, {
                headers: {
                    'content-type': 'multiple/form-data'
                }
            })
                .then(function (response) {
                    if (response.status == 200 || response.status == 201) {
                        Swal.fire({
                            title: 'Data has been updated',
                            icon: 'success',
                            timer: 2000,
                            showConfirmButton: false
                        });
                        setTimeout(() => {
                            window.location.href = ('/surgery-type/');
                        }, 2000);
                    }
                });
        } catch (error) {
            console.log(error);
        }
    };
    useEffect(() => {
        fetchData();
    }, []);
    useEffect(() => {
        if (viewsur.length > 0) {
            setRows(viewsur);
        }
    }, [viewsur]);
    function fetchData() {
        setIsLoading(true);
        axios.get(`${baseUrl}surgery-type-create/`)
            .then(response => {
                setViewsur(response.data);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }
    const handleDelete = (id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result) => {
            if (result.isConfirmed) {
                try {
                    axios.delete(baseUrl + 'delete-surgery-type/' + id)
                        .then(function (response) {
                            Swal.fire('success', 'Data has been Deleted');
                        })
                    setTimeout(() => {
                        window.location.href = ('/surgery-type/');
                    }, 2000);
                } catch (error) {
                    Swal.fire('error', 'Data has not been deleted');
                }
            } else {
                Swal.fire('error', 'Data has not been deleted');
            }
        })
    }
    const columns = [
        {field: 'id', headerName: 'Id', width: 70},
        {field: 'type', headerName: 'Surgery Type', width: 500},
        {field: 'amount', headerName: 'Amount', width: 130},
        {field: 'addedby', headerName: 'Added By', width: 120},
        {
            field: 'edit', headerName: 'Edit',
            renderCell: (params) => (
                <Link to={`/edit-surgery-type/${params.row.id}`} target="_blank" className="btn btn-warning">
                    Edit
                </Link>
            ),
            width: 120
        },
        {
            field: 'delete', headerName: 'Action',
            renderCell: (params) => (
                <button onClick={() => handleDelete(params.row.id)} className="btn btn-danger btn-sm ms-1">
                    <i className="fa-solid fa-trash-can"></i></button>
            ),
            width: 120
        },
    ];
    return (
        <section className="container mt-4">
            <div className="row">

                <div className='col-md-9 col-12 mb-2'>
                    <div className='card'>
                        <h4 className='card-header'>Add Surgery Type</h4>
                        <div className='card-body'>
                            <form>

                                <div className="mb-3">
                                    <label htmlFor="category" className="form-label">Type</label>
                                    <input type="text" className="form-control" name="type" value={typeData.type}
                                           onChange={handleChange} id="type"/>
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="amount" className="form-label">
                                        Amount
                                    </label>

                                    <input
                                        type="number"
                                        className="form-control"
                                        name="amount"
                                        id="amount"
                                        value={typeData.amount}
                                        onChange={handleChange}
                                        min="0"
                                        step="any"
                                        inputMode="decimal"
                                    />
                                </div>

                                <button type="button" onClick={formSubmit} className="btn btn-primary">Submit</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>


            <div style={{height: "100%", width: "100%"}}>
                <DataGrid className="mt-4"
                          sx={{
                              boxShadow: 4,
                              border: 4,
                              borderColor: 'primary.light',
                              '& .MuiDataGrid-cell:hover': {
                                  color: 'primary.main',
                              },
                          }}
                          pageSize={28}
                          rows={rows}
                          columns={columns}
                          components={{
                              Toolbar: GridToolbar,
                          }}
                          autoHeight
                />
            </div>

        </section>
    )
}
export default SurgeryType;